

import React , { useState, useEffect, useCallback} from 'react'
import { Card, Badge, InputGroup, Button, Form, ListGroup, Row, Col, Container} from 'react-bootstrap'
import { ArrowBigDown } from 'lucide-react'
import { Pencil, Check, CirclePlus } from 'lucide-react'
import { CodeView } from '../utils/CodeView'

import axios from 'axios'

import { useSelector, useDispatch } from 'react-redux'


import { X } from 'lucide-react'



export const FeatureCards = ({header, description, icon, code, image}) => {


    const dispatch = useDispatch()

    
  



    useEffect(() => {

      
    }, [])

   
 


    return (

        
          
          <section style={{
               padding: '50px 0',
               background: 'white',
           }}>
               <Container>
                   <Row className="align-items-center">
                   <Col lg={6} className="text-center">
                           <div style={{ marginBottom: '10px' }}>
                               <Badge 
                                   bg="primary" 
                                   style={{ 
                                       fontSize: '1.2rem', 
                                       padding: '6px 12px',
                                       borderRadius: '15px',
                                       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important',
                                       color: 'white'
                                   }}
                               >
                                   {icon} {header}
                               </Badge>
                           </div>
                          
                           <p className="lead mb-4" style={{ 
                               color: '#6c757d', 
                               fontFamily: "Baskervville",
                               fontSize: '1.1rem',
                               lineHeight: '1.6'
                           }}>
                               {description}
                           </p>
                          
                       </Col>
                       <Col lg={6} className="text-center order-lg-2">
                           <div style={{
                               background: 'white',
                               borderRadius: '20px',
                               padding: '40px',
                               boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                               border: '1px solid #e9ecef'
                           }}>
                              
                                 

                            <CodeView text_in={code} />


                          
                           </div>
                       </Col>


                     
                   </Row>
               </Container>
           </section>
         

         
         
     

    )
}


export default FeatureCards
